/**
 * Format timestamp from Java LocalDateTime array or ISO string
 * @param {Array|string} timestamp - LocalDateTime array [year, month, day, hour, minute, second] or ISO string
 * @returns {string} Formatted date string or '-'
 */
export const formatTimestamp = (timestamp) => {
  if (!timestamp) return '-';
  let date;

  if (Array.isArray(timestamp)) {
    const [year, month, day, hour, minute, second] = timestamp;
    // Treats numbers as GMT/UTC
    date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  } else if (typeof timestamp === 'string') {
    const hasTimezone = /[zZ]|[+-]\d{2}:?\d{2}$/.test(timestamp);
    const normalizedValue = hasTimezone ? timestamp : `${timestamp}Z`;
    date = new Date(normalizedValue);
  } else if (typeof timestamp === 'number') {
    date = new Date(timestamp);
  }

  if (!date || Number.isNaN(date.getTime())) {
    return '-';
  }

  return (
    date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }) || '-'
  );
};
